import { saveAs } from 'file-saver'

class MapExporter {
  map = null

  constructor(map) {
    this.map = map
  }

  execute() {
    this.map.once('postcompose', function(event) {
      var canvas = event.context.canvas
      let date = new Date()
      let filename = 'cartoradio' + date.getFullYear() + '' + date.getMonth() + '' + date.getDate() + '' +
        date.getHours() + '' + '' + date.getMinutes() + '' + date.getSeconds() + '' + date.getMilliseconds() + '.png'
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(canvas.msToBlob(), filename)
      } else {
        canvas.toBlob(function(blob) {
          saveAs(blob, filename)
        })
      }
    })
    this.map.renderSync()
  }
}

export default MapExporter
